<template>
    <a-tabs default-active-key="1">
        <a-tab-pane key="1" tab="Vessel">
            <a-divider>Create</a-divider>
            <a-form layout="inline">
                <a-form-item label="Vessel Name">
                    <a-input v-model="vessel_to_create.vessel_name"></a-input>
                </a-form-item>
                <a-form-item label="CP Date">
                    <a-date-picker v-model="vessel_to_create.cpdate" :valueFormat="'YYYY-MM-DD'" />
                </a-form-item>
                <a-form-item>
                    <a-button type="primary" @click="() => {
                        vue_instance.$http.post(vue_instance.$store.state.base_url + '/capt_xu_vessels/c', {
                            vessel_name: vue_instance.vessel_to_create.vessel_name,
                            cpdate: vue_instance.vessel_to_create.cpdate,
                        }).then((r) => {
                            capt_xu_vessels.push(r.data.data[0]);
                        });
                    }">Create</a-button>
                </a-form-item>
            </a-form>
            <a-divider>Vessle List</a-divider>
            <a-table rowKey="id" :data-source="capt_xu_vessels" :columns="vsl_columns">
                <div slot="filterDropdown" slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
                    style="padding: 8px">
                    <a-input v-ant-ref="c => (searchInput = c)" :placeholder="`Search ${column.dataIndex}`"
                        :value="selectedKeys[0]" style="width: 188px; margin-bottom: 8px; display: block;"
                        @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                        @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)" />
                    <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
                        @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)">
                        Search
                    </a-button>
                    <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">
                        Reset
                    </a-button>
                </div>
                <a-icon slot="filterIcon" slot-scope="filtered" type="search"
                    :style="{ color: filtered ? '#108ee9' : undefined }" />
                <template slot="customRender" slot-scope="text, record, index, column">
                    <span v-if="searchText && searchedColumn === column.dataIndex">
                        <template v-for="(fragment, i) in text
                            .toString()
                            .split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i'))">
                            <mark v-if="fragment.toLowerCase() === searchText.toLowerCase()" :key="i"
                                class="highlight">{{ fragment }}</mark>
                            <template v-else>{{ fragment }}</template>
                        </template>
                    </span>
                    <template v-else>
                        {{ text }}
                    </template>
                </template>

                <template slot="payout_counter" slot-scope="text, record">
                    <span style="color: green;font-weight: bold;">
                        Y
                    </span>:{{record.capt_xu_payouts.filter(p => p.is_paid).length}}
                    /<span style="color: red;font-weight: bold;">
                        N
                    </span>:{{record.capt_xu_payouts.filter(p => !p.is_paid).length}}
                </template>
                <template slot="action" slot-scope="text, record">
                    <a-button type="link" size="small" @click="() => {
                        vessel_edit_modal = true
                        vessel_to_edit = { ...record }
                    }">
                        Edit
                    </a-button>
                </template>
            </a-table>

            <a-modal v-model="vessel_edit_modal" title="Vessel Edit" @ok="() => {
                vue_instance.$http.post(vue_instance.$store.state.base_url + '/capt_xu_vessels/u', {
                    id: vessel_to_edit.id,
                    cpdate: vessel_to_edit.cpdate,
                    vessel_name: vessel_to_edit.vessel_name,
                }).then((r) => {
                    vessel_edit_modal = false;
                    const index = capt_xu_vessels.findIndex(v => v.id === vessel_to_edit.id);
                    capt_xu_vessels[index].cpdate = vessel_to_edit.cpdate;
                    capt_xu_vessels[index].vessel_name = vessel_to_edit.vessel_name;
                });
            }" @cancel="() => {
                vessel_edit_modal = false;
            }">
                <a-form layout="vertical" style="margin: 10px 0;">
                    <a-form-item label="Date">
                        <a-date-picker v-model="vessel_to_edit.cpdate" :valueFormat="'YYYY-MM-DD'" />
                    </a-form-item>
                    <a-form-item label="Item Name">
                        <a-input v-model="vessel_to_edit.vessel_name"></a-input>
                    </a-form-item>
                </a-form>
            </a-modal>


        </a-tab-pane>
        <a-tab-pane key="2" tab="Payout" force-render>
            <a-table rowKey="id" :data-source="capt_xu_vessels" :columns="vsl_columns"
                @expand="() => { selected_payout = [] }">
                <div slot="filterDropdown" slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
                    style="padding: 8px">
                    <a-input v-ant-ref="c => (searchInput = c)" :placeholder="`Search ${column.dataIndex}`"
                        :value="selectedKeys[0]" style="width: 188px; margin-bottom: 8px; display: block;"
                        @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                        @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)" />
                    <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
                        @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)">
                        Search
                    </a-button>
                    <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">
                        Reset
                    </a-button>
                </div>
                <a-icon slot="filterIcon" slot-scope="filtered" type="search"
                    :style="{ color: filtered ? '#108ee9' : undefined }" />
                <template slot="customRender" slot-scope="text, record, index, column">
                    <span v-if="searchText && searchedColumn === column.dataIndex">
                        <template v-for="(fragment, i) in text
                            .toString()
                            .split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i'))">
                            <mark v-if="fragment.toLowerCase() === searchText.toLowerCase()" :key="i"
                                class="highlight">{{ fragment }}</mark>
                            <template v-else>{{ fragment }}</template>
                        </template>
                    </span>
                    <template v-else>
                        {{ text }}
                    </template>
                </template>
                <template slot="payout_counter" slot-scope="text, record">
                    <span style="color: green;font-weight: bold;">
                        Y
                    </span>:{{record.capt_xu_payouts.filter(p => p.is_paid).length}}
                    /<span style="color: red;font-weight: bold;">
                        N
                    </span>:{{record.capt_xu_payouts.filter(p => !p.is_paid).length}}
                </template>
                <template slot="expandedRowRender" slot-scope="record">
                    <a-form layout="inline" style="margin: 10px 0;">
                        <a-form-item label="ADD A Payout">
                            <a-input-group compact>
                                <a-date-picker style="width:200px" v-model="payout_to_create.date"
                                    :valueFormat="'YYYY-MM-DD'" />
                                <a-input style="width:200px" v-model="payout_to_create.item_name"
                                    placeholder="Item Name"></a-input>
                                <a-input style="width:200px" v-model="payout_to_create.beneficiary"
                                    placeholder="Beneficiary"></a-input>
                                <a-input style="width:200px" v-model="payout_to_create.amount" step="0.01" min="0"
                                    type="number" placeholder="Amount"></a-input>
                                <a-input style="width:200px" v-model="payout_to_create.remarks"
                                    placeholder="Remarks"></a-input>
                                <a-button type="primary" @click="() => {
                                    vue_instance.$http.post(vue_instance.$store.state.base_url + '/capt_xu_payouts/c', {
                                        capt_xu_vsl_id: record.id,
                                        date: vue_instance.payout_to_create.date,
                                        item_name: vue_instance.payout_to_create.item_name,
                                        beneficiary: vue_instance.payout_to_create.beneficiary,
                                        amount: vue_instance.payout_to_create.amount,
                                        remarks: vue_instance.payout_to_create.remarks,
                                        is_paid: vue_instance.payout_to_create.is_paid,
                                    }).then((r) => {
                                        payout_to_create.date = '';
                                        payout_to_create.item_name = '';
                                        payout_to_create.beneficiary = '';
                                        payout_to_create.amount = '';
                                        payout_to_create.remarks = '';
                                        record.capt_xu_payouts.push(r.data.data[0]);
                                        capt_xu_payouts.push(r.data.data[0]);
                                    });
                                }">Create</a-button>
                            </a-input-group>
                        </a-form-item>
                        <a-form-item>
                            <a-button type="primary" @click="send_mail"> Send Selected as Email</a-button>
                        </a-form-item>
                    </a-form>
                    <a-divider></a-divider>

                    <a-table rowKey="id" :data-source="record.capt_xu_payouts" :columns="payout_columns"
                        :rowSelection="{ selectedRowKeys: selected_payout, onChange: change_selected_payout }">
                        <template slot="upload" slot-scope="text, record">
                            <div v-for="(a, a_pos) in record.attachment" :key="a.uid">
                                <a :href="a.url">
                                    {{ a.filename }}
                                </a>
                                <a-popconfirm title="Are you sure delete this File?" ok-text="Yes" cancel-text="No"
                                    @confirm="() => {
                                        CONSOLE.log('delete file', a, record);
                                        record.attachment.splice(a_pos, 1);
                                        vue_instance.$http.post(vue_instance.$store.state.base_url + '/capt_xu_payouts/u', {
                                            ...record,
                                        })
                                    }">
                                    <a-icon style="color:red;cursor:pointer" type="close-circle" />
                                </a-popconfirm>
                            </div>
                        </template>
                        <template slot="is_paid" slot-scope="text, record">
                            <span v-if="record.is_paid" style="font-weight: bold; color: green;">Y</span>
                            <span v-else style="font-weight: bold; color: red;">N</span>
                        </template>
                        <template slot="action" slot-scope="text, record">
                            <a-button type="link" href="#" @click="() => {
                                DOCUMENT.getElementById('upload_payout_file_' + record.id).click();
                                return false;
                            }">Upload Payout File</a-button>
                            <input type="file" :id="'upload_payout_file_' + record.id" style="display: none;"
                                @change="(e) => { upload_file(e, record) }" />
                            <a-popconfirm title="Are you sure delete this Payout?" ok-text="Yes" cancel-text="No"
                                @confirm="() => {
                                    vue_instance.$http.post(vue_instance.$store.state.base_url + '/capt_xu_payouts/d', {
                                        id: record.id,
                                    }).then((r) => {
                                        const index = capt_xu_vessels.find(v => v.id === record.capt_xu_vsl_id).capt_xu_payouts.findIndex(p => p.id === record.id);
                                        if (index > -1) {
                                            capt_xu_vessels.find(v => v.id === record.capt_xu_vsl_id).capt_xu_payouts.splice(index, 1);
                                        }
                                    });
                                }">

                                <a-button type="link" size="small" @click="() => {
                                    payout_edit_visible = true
                                    payout_to_edit = { ...record }
                                }">
                                    Edit
                                </a-button>

                                <a-button type="link" size="small"><span style="color:red;">Delete</span></a-button>
                            </a-popconfirm>
                        </template>
                    </a-table>
                </template>
            </a-table>

            <a-modal v-model="payout_edit_visible" title="Payouts Edit Modal" @ok="() => {
                vue_instance.$http.post(vue_instance.$store.state.base_url + '/capt_xu_payouts/u', {
                    id: payout_to_edit.id,
                    date: payout_to_edit.date,
                    item_name: payout_to_edit.item_name,
                    beneficiary: payout_to_edit.beneficiary,
                    amount: payout_to_edit.amount,
                    remarks: payout_to_edit.remarks,
                }).then((r) => {
                    const index = capt_xu_vessels.findIndex(v => v.id === payout_to_edit.capt_xu_vsl_id);
                    if (index > -1) {
                        const payoutIndex = capt_xu_vessels[index].capt_xu_payouts.findIndex(p => p.id === payout_to_edit.id);
                        if (payoutIndex > -1) {
                            capt_xu_vessels[index].capt_xu_payouts.splice(payoutIndex, 1, payout_to_edit);
                        }
                    }
                    payout_edit_visible = false;
                });
            }" @cancel="() => {
                payout_edit_visible = false;
            }">
                <a-form layout="vertical" style="margin: 10px 0;">
                    <a-form-item label="Date">
                        <a-date-picker v-model="payout_to_edit.date" :valueFormat="'YYYY-MM-DD'" />
                    </a-form-item>
                    <a-form-item label="Item Name">
                        <a-input v-model="payout_to_edit.item_name"></a-input>
                    </a-form-item>
                    <a-form-item label="Beneficiary">
                        <a-input v-model="payout_to_edit.beneficiary"></a-input>
                    </a-form-item>
                    <a-form-item label="Amount" step="0.01" min="0" type="number">
                        <a-input v-model="payout_to_edit.amount"></a-input>
                    </a-form-item>
                    <a-form-item label="Remarks">
                        <a-input v-model="payout_to_edit.remarks"></a-input>
                    </a-form-item>
                </a-form>
            </a-modal>
        </a-tab-pane>
        <a-tab-pane key="3" tab="Income" force-render>
            <a-table rowKey="id" :data-source="capt_xu_vessels" :columns="vsl_columns">
                <div slot="filterDropdown" slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
                    style="padding: 8px">
                    <a-input v-ant-ref="c => (searchInput = c)" :placeholder="`Search ${column.dataIndex}`"
                        :value="selectedKeys[0]" style="width: 188px; margin-bottom: 8px; display: block;"
                        @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                        @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)" />
                    <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
                        @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)">
                        Search
                    </a-button>
                    <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">
                        Reset
                    </a-button>
                </div>
                <a-icon slot="filterIcon" slot-scope="filtered" type="search"
                    :style="{ color: filtered ? '#108ee9' : undefined }" />
                <template slot="customRender" slot-scope="text, record, index, column">
                    <span v-if="searchText && searchedColumn === column.dataIndex">
                        <template v-for="(fragment, i) in text
                            .toString()
                            .split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i'))">
                            <mark v-if="fragment.toLowerCase() === searchText.toLowerCase()" :key="i"
                                class="highlight">{{ fragment }}</mark>
                            <template v-else>{{ fragment }}</template>
                        </template>
                    </span>
                    <template v-else>
                        {{ text }}
                    </template>
                </template>
                <template slot="payout_counter" slot-scope="text, record">
                    <span style="color: green;font-weight: bold;">
                        Y
                    </span>:{{record.capt_xu_incomes.filter(p => p.is_received).length}}
                    /<span style="color: red;font-weight: bold;">
                        N
                    </span>:{{record.capt_xu_incomes.filter(p => !p.is_received).length}}
                </template>
                <template slot="expandedRowRender" slot-scope="record">
                    <a-form layout="inline" style="margin: 10px 0;">
                        <a-form-item label="ADD a Income">
                            <a-input-group compact>
                                <a-date-picker style="width:200px" v-model="income_to_create.date"
                                    :valueFormat="'YYYY-MM-DD'" />
                                <a-input style="width:200px" v-model="income_to_create.item_name"
                                    placeholder="Item Name"></a-input>
                                <a-input style="width:200px" v-model="income_to_create.messrs"
                                    placeholder="MESSRS"></a-input>
                                <a-input style="width:200px" v-model="income_to_create.amount"
                                    placeholder="Amount"></a-input>
                                <a-input style="width:200px" v-model="income_to_create.remarks"
                                    placeholder="Remarks"></a-input>
                                <a-button type="primary" @click="() => {
                                    vue_instance.$http.post(vue_instance.$store.state.base_url + '/capt_xu_incomes/c', {
                                        capt_xu_vsl_id: record.id,
                                        date: vue_instance.income_to_create.date,
                                        item_name: vue_instance.income_to_create.item_name,
                                        messrs: vue_instance.income_to_create.messrs,
                                        amount: vue_instance.income_to_create.amount,
                                        remarks: vue_instance.income_to_create.remarks,
                                        is_received: vue_instance.income_to_create.is_received,
                                    }).then((r) => {
                                        income_to_create.date = '';
                                        income_to_create.item_name = '';
                                        income_to_create.messrs = '';
                                        income_to_create.amount = '';
                                        income_to_create.remarks = '';
                                        record.capt_xu_incomes.push(r.data.data[0]);
                                    });
                                }">
                                    Create
                                </a-button>
                            </a-input-group>
                        </a-form-item>
                    </a-form>
                    <a-divider></a-divider>

                    <a-table rowKey="id" :data-source="record.capt_xu_incomes" :columns="income_columns">
                        <template slot="upload" slot-scope="text, record">
                            <div v-for="(a, a_pos) in record.attachment" :key="a.uid">
                                <a :href="a.url">
                                    {{ a.filename }}
                                </a>
                                <a-popconfirm title="Are you sure delete this File?" ok-text="Yes" cancel-text="No"
                                    @confirm="() => {
                                        CONSOLE.log('delete file', a, record);
                                        record.attachment.splice(a_pos, 1);
                                        vue_instance.$http.post(vue_instance.$store.state.base_url + '/capt_xu_incomes/u', {
                                            ...record,
                                        })
                                    }">
                                    <a-icon style="color:red;cursor:pointer" type="close-circle" />
                                </a-popconfirm>
                            </div>
                        </template>
                        <template slot="is_received" slot-scope="text, record">
                            <span v-if="record.is_received" style="font-weight: bold; color: green;">Y</span>
                            <span v-else style="font-weight: bold; color: red;">N</span>
                        </template>
                        <template slot="action" slot-scope="text, record">
                            <a-button type="link" href="#" @click="() => {
                                DOCUMENT.getElementById('upload_income_file_' + record.id).click();
                                return false;
                            }">Upload Income File</a-button>
                            <input type="file" :id="'upload_income_file_' + record.id" style="display: none;"
                                @change="e => { upload_file(e, record) }" />
                            <a-popconfirm title="Are you sure delete this Income?" ok-text="Yes" cancel-text="No"
                                @confirm="() => {
                                    vue_instance.$http.post(vue_instance.$store.state.base_url + '/capt_xu_incomes/d', {
                                        id: record.id,
                                    }).then((r) => {
                                        const index = capt_xu_vessels.find(v => v.id === record.capt_xu_vsl_id).capt_xu_incomes.findIndex(p => p.id === record.id);
                                        if (index > -1) {
                                            capt_xu_vessels.find(v => v.id === record.capt_xu_vsl_id).capt_xu_incomes.splice(index, 1);
                                        }
                                    });
                                }">
                                <a-button type="link" size="small" @click="() => {
                                    income_edit_visible = true
                                    income_to_edit = { ...record }
                                }">
                                    Edit
                                </a-button>

                                <a-button type="link" size="small"><span style="color:red;">Delete</span></a-button>
                            </a-popconfirm>
                        </template>
                    </a-table>
                </template>

            </a-table>

            <a-modal v-model="income_edit_visible" title="Income Edit Modal" @ok="() => {
                vue_instance.$http.post(vue_instance.$store.state.base_url + '/capt_xu_incomes/u', {
                    id: income_to_edit.id,
                    date: income_to_edit.date,
                    item_name: income_to_edit.item_name,
                    messrs: income_to_edit.messrs,
                    amount: income_to_edit.amount,
                    remarks: income_to_edit.remarks,
                }).then((r) => {
                    const index = capt_xu_vessels.findIndex(v => v.id === income_to_edit.capt_xu_vsl_id);
                    if (index > -1) {
                        const incomeIndex = capt_xu_vessels[index].capt_xu_incomes.findIndex(p => p.id === income_to_edit.id);
                        if (incomeIndex > -1) {
                            capt_xu_vessels[index].capt_xu_incomes.splice(incomeIndex, 1, income_to_edit);
                        }
                    }
                    income_edit_visible = false;
                });
            }" @cancel="() => {
                income_edit_visible = false;
            }">
                <a-form layout="vertical" style="margin: 10px 0;">
                    <a-form-item label="Date">
                        <a-date-picker v-model="income_to_edit.date" :valueFormat="'YYYY-MM-DD'" />
                    </a-form-item>
                    <a-form-item label="Item Name">
                        <a-input v-model="income_to_edit.item_name"></a-input>
                    </a-form-item>
                    <a-form-item label="Messrs">
                        <a-input v-model="income_to_edit.messrs"></a-input>
                    </a-form-item>
                    <a-form-item label="Amount">
                        <a-input v-model="income_to_edit.amount"></a-input>
                    </a-form-item>
                    <a-form-item label="Remarks">
                        <a-input v-model="income_to_edit.remarks"></a-input>
                    </a-form-item>
                </a-form>
            </a-modal>
        </a-tab-pane>
    </a-tabs>
</template>


<script>
import userinfo from "../../utils/userinfo.js";

export default {
    name: "capt_xu_vsl_mgt_cost",
    data() {
        return {
            email_draft: {
                subject: "",
                to: ["ops@comergegroup.com"],
                cc: [
                    "document@comergegroup.com",
                    "acct@comergegroup.com",
                    "acctcomerge@protonmail.com",
                    "projects@comergegroup.com"
                ],
                // cc: ["document@comergegroup.com", "ops@comergegroup.com"],
                content_html: "<html></html>",
                payout_id: [],
            },
            selected_payout: [],

            vue_instance: this,
            CONSOLE: console,
            vessel_to_create: {
                vessel_name: '',
                cpdate: '',
            },
            vessel_to_edit: {
            },
            payout_to_create: {
                date: '',
                item_name: '',
                beneficiary: '',
                amount: null,
                remarks: '',
                is_paid: false,
            },
            payout_to_edit: {
            },
            income_to_create: {
                date: '',
                item_name: '',
                beneficiary: '',
                amount: null,
                remarks: '',
                is_received: false,
            },
            income_to_edit: {
            },


            capt_xu_vessels: [],
            capt_xu_payouts: [],
            capt_xu_incomes: [],

            headers: {
                access_token: userinfo.get().access_token,
            },

            userinfo: userinfo.get(),
            searchText: '',
            searchInput: null,
            searchedColumn: '',

            income_edit_visible: false,
            payout_edit_visible: false,
            vessel_edit_modal: false,
            DOCUMENT: document,

            vsl_columns: [
                {
                    title: 'ID',
                    dataIndex: 'id',
                    key: 'id',
                },
                {
                    title: 'Vessel Name',
                    dataIndex: 'vessel_name',
                    key: 'vessel_name',
                    scopedSlots: {
                        filterDropdown: 'filterDropdown',
                        filterIcon: 'filterIcon',
                        customRender: 'customRender',
                    },
                    onFilter: (value, record) =>
                        record.vessel_name
                            .toString()
                            .toLowerCase()
                            .includes(value.toLowerCase()),
                    onFilterDropdownVisibleChange: visible => {
                        if (visible) {
                            setTimeout(() => {
                                this.searchInput.focus();
                            }, 0);
                        }
                    },
                },
                {
                    title: 'CP date',
                    dataIndex: 'cpdate',
                    key: 'cpdate',
                },
                {
                    title: 'Payout Counter',
                    dataIndex: 'payout_counter',
                    key: 'payout_counter',
                    align: 'center',
                    scopedSlots: { customRender: "payout_counter" },
                },
                {
                    title: 'Action',
                    dataIndex: 'action',
                    key: 'action',
                    align: 'center',
                    scopedSlots: { customRender: "action" },
                }
            ],
            payout_columns: [
                {
                    title: 'ID',
                    dataIndex: 'id',
                    key: 'id',
                    align: 'center',
                },
                {
                    title: 'Date',
                    dataIndex: 'date',
                    key: 'date',
                    align: 'center',
                },
                {
                    title: 'Item Name',
                    dataIndex: 'item_name',
                    key: 'item_name',
                    align: 'center',
                },
                {
                    title: 'Beneficiary',
                    dataIndex: 'beneficiary',
                    key: 'beneficiary',
                    align: 'center',
                },
                {
                    title: 'Amount',
                    dataIndex: 'amount',
                    key: 'amount',
                    align: 'center',
                },
                {
                    title: 'Remarks',
                    dataIndex: 'remarks',
                    key: 'remarks',
                    align: 'center',
                },
                {
                    title: 'Is Paid',
                    dataIndex: 'is_paid',
                    key: 'is_paid',
                    align: 'center',
                    scopedSlots: { customRender: "is_paid" },
                },
                {
                    title: "Upload",
                    dataIndex: "upload",
                    key: "upload",
                    align: 'center',
                    scopedSlots: { customRender: "upload" },
                },
                {
                    title: 'Actions',
                    dataIndex: 'actions',
                    key: 'actions',
                    align: 'center',
                    scopedSlots: { customRender: "action" },
                }
            ],
            income_columns: [
                {
                    title: 'ID',
                    dataIndex: 'id',
                    key: 'id',
                    align: 'center',
                },
                {
                    title: 'Date',
                    dataIndex: 'date',
                    key: 'date',
                    align: 'center',
                },
                {
                    title: 'Item Name',
                    dataIndex: 'item_name',
                    key: 'item_name',
                    align: 'center',
                },
                {
                    title: 'MESSRS',
                    dataIndex: 'messrs',
                    key: 'messrs',
                    align: 'center',
                },
                {
                    title: 'Amount',
                    dataIndex: 'amount',
                    key: 'amount',
                    align: 'center',
                },
                {
                    title: 'Remarks',
                    dataIndex: 'remarks',
                    key: 'remarks',
                    align: 'center',
                },
                {
                    title: 'Is Received',
                    dataIndex: 'is_received',
                    key: 'is_received',
                    align: 'center',
                    scopedSlots: { customRender: "is_received" },
                },
                {
                    title: "Upload",
                    dataIndex: "upload",
                    key: "upload",
                    align: 'center',
                    scopedSlots: { customRender: "upload" },
                },
                {
                    title: 'Actions',
                    dataIndex: 'actions',
                    key: 'actions',
                    align: 'center',
                    scopedSlots: { customRender: "action" },
                }
            ],
        };
    },
    methods: {
        handleSearch(selectedKeys, confirm, dataIndex) {
            confirm();
            this.searchText = selectedKeys[0];
            this.searchedColumn = dataIndex;
        },
        handleReset(clearFilters) {
            clearFilters();
            this.searchText = '';
        },
        upload_file(e, record) {
            console.log("upload file target record:", record);
            const file = e.target.files[0];
            const formData = new FormData();
            formData.append("file", file);
            formData.append("related_id", record.id);
            this.$http.post(this.$store.state.base_url + "/upload", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    access_token: this.userinfo.access_token,
                },
            })
                .then((res) => {
                    if (res.data.status == 1) {
                        if (!record.hasOwnProperty("attachment")) {
                            this.$set(record, "attachment", []);
                        }
                        for (var i = 0; i < res.data.data.length; i++) {
                            var tmp = {};
                            tmp.name = res.data.data[i].filename;
                            tmp.filename = res.data.data[i].filename;
                            tmp.uid = res.data.data[i].path;
                            tmp.path = res.data.data[i].path;
                            tmp.url = this.$store.state.site_url + res.data.data[i].path;
                            tmp.status = "done";
                            record.attachment.push(tmp);
                        }
                        console.log("updated record:", record);
                        if (record.hasOwnProperty("is_paid")) {
                            this.$http.post(this.$store.state.base_url + "/capt_xu_payouts/u", { ...record });
                        } else if (record.hasOwnProperty("is_received")) {
                            this.$http.post(this.$store.state.base_url + "/capt_xu_incomes/u", { ...record });
                        }
                    }
                });
        },


        change_selected_payout(selectedRowKeys) {
            this.selected_payout = selectedRowKeys;
            this.email_draft.payout_id = this.selected_payout;
            var payouts = [];
            if (this.selected_payout.length !== 0) {
                this.selected_payout.forEach((s) => {
                    this.capt_xu_payouts.forEach((t) => {
                        if (t.id == s) {
                            payouts.push(t);
                        }
                    });
                });
            }
            this.email_draft.content_html = "";
            this.email_draft.subject = "Capt Zhao's payment notice - (";
            payouts.forEach((p) => {
                this.email_draft.subject =
                    this.email_draft.subject +
                    "ID:" +
                    p.capt_xu_vsl_id +
                    "/" +
                    p.capt_xu_vsl_name +
                    "/" +
                    p.amount.toLocaleString("en-US", { style: "currency", currency: "USD" }) +
                    " , ";

                this.email_draft.content_html =
                    this.email_draft.content_html +
                    "<tr>" +
                    "<td>" +
                    p.id +
                    "</td>" +
                    "<td>" +
                    p.capt_xu_vsl_id +
                    "</td>" +
                    "<td>" +
                    p.capt_xu_vsl_name +
                    "</td>" +
                    "<td>" +
                    p.date +
                    "</td>" +
                    "<td>" +
                    p.beneficiary +
                    "</td>" +
                    "<td>" +
                    p.item_name +
                    "</td>" +
                    "<td>" +
                    p.amount.toLocaleString("en-US", { style: "currency", currency: "USD" }) +
                    "</td>" +
                    "<td>" +
                    p.remarks +
                    "</td>"
                this.email_draft.content_html = this.email_draft.content_html + "<td>";
                p.attachment.forEach((a) => {
                    this.email_draft.content_html =
                        this.email_draft.content_html +
                        "<a href='" +
                        a.url +
                        "'>" +
                        a.filename +
                        "</a><br>";
                });
                this.email_draft.content_html = this.email_draft.content_html + "</td>";
            });

            this.email_draft.subject = this.email_draft.subject.substr(
                0,
                this.email_draft.subject.length - 2
            );

            this.email_draft.subject = this.email_draft.subject + ")";
            if (this.email_draft.subject.length > 128) {
                this.email_draft.subject = this.email_draft.subject.substr(0, 120) + "...";
            }

            this.email_draft.content_html =
                "<html><table border = '1'>" +
                "<tr><td>ID</td><td>Vessel ID</td><td>Vessel Name</td><td>Date</td><td>Beneficiary</td><td>Items</td><td>Amount</td><td>Remarks</td><td>Payment Notice Link</td></tr>" +
                this.email_draft.content_html +
                "</table></html>";
            console.log("email draft:", this.email_draft);
        },

        send_mail() {
            this.$http
                .post(this.$store.state.base_url + "/sendmail", this.email_draft)
                .then((res) => {
                    if (res.data.status == 1) {
                        this.$message.info("Send Emails Success");
                        this.modal_send_emails = false;
                    }
                });
        },
    },

    mounted() {
        this.$http.post(this.$store.state.base_url + "/capt_xu_payouts/r", {}).then((res) => {
            this.capt_xu_payouts = res.data.data;
        })
        this.$http.post(this.$store.state.base_url + "/capt_xu_vessels/r", {}).then((res) => {
            this.capt_xu_vessels = res.data.data;
        })
        this.$http.post(this.$store.state.base_url + "/capt_xu_incomes/r", {}).then((res) => {
            this.capt_xu_incomes = res.data.data;
        })
    },
    watch: {

    },
};

</script>